<template>
    <card-seplag titulo="Órgãos Vinculados">
        <div class="p-col-12">
            <div class="p-grid alinhamentoBuscaOrgaoVinculado">
                <Rotulo nome="Selecione um Órgão:" cols="12 6">
                    <Dropdown v-model="orgaoSelecionado" :options="orgaoBusca" optionLabel="labelDropDaw"
                        placeholder="Selecione..." :filter="true" />
                </Rotulo>
                <div class="p-col-12 p-md-4">
                    <Button label="Buscar" class="p-button-info" icon="pi pi-search" @click="buscaOrgaoVinculado()" />
                </div>
            </div>
        </div>
        <div class="p-col-12" v-if="orgaosDisponiveis.length > 0">
            <label><strong>Selecione os Orgãos Vinculados: </strong></label>
        </div>
        <div class="p-col-12 orgaosVinculados" v-if="orgaosDisponiveis.length > 0">
            <DataTable :value="orgaosDisponiveis">
                <Column header="#" headerStyle="width:7%;" :bodyStyle='"text-align: center;"'>
                    <template #body="slotProps">
                        <Checkbox :id="slotProps.data.idenOrgao" :inputId="slotProps.data.idenOrgao"
                            name="orgaoVinculados" :value="slotProps.data" v-model="orgaosVinculados"
                            :disabled="orgaoSelecionado == null" />
                    </template>
                </Column>
                <Column field="codSeap" header="Cód Seap"></Column>
                <Column field="descOrgao" header="Orgão Vinculado"></Column>
            </DataTable>
        </div>
        <div class="p-col-12 p-md-4" v-if="orgaosDisponiveis.length > 0">
            <Button label="Salvar" class="p-button-success" icon="pi pi-save" @click="abrirModalSalvar()" />
        </div>

        <!-- Modal Orgãos Extintos com Vinculo Redmine #23322 -->
        <Dialog :visible.sync="exibirOrgaoExtinto" :header="'Atenção!!'" :modal="true" class="cadastro-rapido-seplag"
            :closable="true">
            <div class="p-col-12 divTabelaSetor" v-if="orgaosVinculadosExtintos.length > 0">
                <p>O(s) órgão(s) abaixo consta(m) como extinto(s), confirma a desvinculação? Esta etapa é necessária
                    para novas
                    vinculações.</p>
                <br>
                <DataTable :value="this.orgaosVinculadosExtintos" :paginator="true" :rows="10"
                    paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                    :rowsPerPageOptions="[10, 20, 50]"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" selectionMode="multiple">
                    <Column field="orgaoVinculadoId.orgaoPrincipal.descOrgao" header="Orgao Principal"></Column>
                    <Column field="orgaoVinculadoId.orgaoPrincipal.flagExtinto" header="Extinto"></Column>
                    <Column field="orgaoVinculadoId.orgaoVinculado.descOrgao" header="Orgao Vinculado"></Column>
                    <Column field="orgaoVinculadoId.orgaoVinculado.flagExtinto" header="Extinto"></Column>
                </DataTable>
                <br>
                <div class="p-col-12 p-grid p-align-end p-justify-end">
                    <template>
                        <div class="p-md-2">
                            <Button :label="'Sim'" icon="pi pi-check" @click="excluirVinculosExtintos"
                                class="p-button-success" />
                        </div>
                        <div class="p-md-2">
                            <Button :label="'Não'" icon="pi pi-times" @click="fecharModalOrgaosExtintos"
                                class="p-button-danger" />
                        </div>
                    </template>
                </div>
            </div>
        </Dialog>

        <Dialog :visible.sync="exibirConfirmacao" :header="'Atenção!!'" :modal="true" class="cadastro-rapido-seplag"
            :closable="false">
            <div class="p-grid alinhamentoBuscaOrgaoVinculado">
                <p class="alinamentoTextoModalOrgaoVinculado">Ao Salvar os órgãos, todos os gestores setoriais do órgão
                    {{ orgaoSelecionado ? orgaoSelecionado.descOrgao : '' }} terá alteração em seus Acessos.</p>
                <p class="alinamentoTextoModalOrgaoVinculado"> Tem certeja de que deseja continuar?</p>
            </div>
            <template #footer>
                <Button :label="'Sim'" icon="pi pi-check" @click="salvarOrgaoVinculado" class="p-button-success" />

                <Button :label="'Não'" icon="pi pi-times" @click="fecharModalConfirmacaoOrgaovInculado"
                    class="p-button-danger" />
            </template>
        </Dialog>
    </card-seplag>
</template>

<script>
import CardSeplag from '@/template/CardSeplag.vue'
import Rotulo from '@/template/RotuloSeplag.vue'
import { baseApiUrl } from '@/config/global'

export default {
    name: 'orgaoVinculado',
    components: { CardSeplag, Rotulo },
    data: function () {
        return {
            exibirConfirmacao: false,
            orgaoBusca: [],
            orgaosVinculados: [],
            orgaosDisponiveis: [],
            orgaoSelecionado: null,

            //redmine #23322
            orgaosVinculadosExtintos: [],
            exibirOrgaoExtinto: false,
        }
    },
    methods: {
        async carregarDados() {
            this.$http.get(`${baseApiUrl}/orgaos/naoextintos`).then(res => {
                this.orgaoBusca = res.data.map(function (element) {
                    return {
                        ...element,
                        labelDropDaw: element.codSeap + " - " + element.descOrgao,
                    };
                });
                this.orgaosDisponiveis = res.data
            })

            //redmine #23322
            const resExtintos = await this.$http.get(`${baseApiUrl}/orgaos/extintoscomvinculo`);
            this.orgaosVinculadosExtintos = resExtintos.data;

            if (this.orgaosVinculadosExtintos.length > 0) {
                this.exibirOrgaoExtinto = true;
            }
        },
        buscaOrgaoVinculado() {
            this.$http.get(`${baseApiUrl}/orgaos/vinculados/${this.orgaoSelecionado.idenOrgao}`).then(res => {
                this.orgaosVinculados = res.data
                this.orgaosDisponiveis = this.orgaosDisponiveis.sort(function (orgao1, orgao2) {
                    if (orgao1.descOrgao > orgao2.descOrgao) {
                        return 1;
                    }
                    if (orgao1.descOrgao < orgao2.descOrgao) {
                        return -1;
                    }
                    // a must be equal to b
                    return 0;
                })
            })
        },
        abrirModalSalvar() {
            this.exibirConfirmacao = true
        },
        salvarOrgaoVinculado() {   
            this.$http.put(`${baseApiUrl}/orgaosvinculadossistema/adicionar/${this.orgaoSelecionado.idenOrgao}`, JSON.stringify(this.orgaosVinculados)).then(() => {
                this.$toast.add({ severity: 'success', summary: 'Ação Efetuada', detail: "Órgãos Vinculados Com Sucesso!", life: 5000 });
                this.fecharModalConfirmacaoOrgaovInculado();
            })
        },
        fecharModalConfirmacaoOrgaovInculado() {
            this.exibirConfirmacao = false
        },

        //redmine #23322
        excluirVinculosExtintos() {
            this.$http.put(`${baseApiUrl}/orgaos/excluirorgaovinculadoextintos`).then(() => {
                this.$toast.add({ severity: 'success', summary: 'Ação Efetuada', detail: "Órgãos Vinculados Com Sucesso!", life: 5000 });
                this.fecharModalOrgaosExtintos()
            })
        },
        fecharModalOrgaosExtintos() {
            this.exibirOrgaoExtinto = false
        }
    },
    mounted() {
        this.carregarDados()
    }
}
</script>

<style>
.alinhamentoBuscaOrgaoVinculado {
    align-items: flex-end;
    justify-content: center;
}

.alinamentoTextoModalOrgaoVinculado {
    text-align: center;
}
</style>
